export default "__VITE_ASSET__fogj1hdg__"